import { AccountDisplayNamePipe } from './account-display-name.pipe';
import { DprModalTitlePipe } from './dpr-modal-title.pipe';
import { DprTitlePipe } from './dpr-title.pipe';
import { FilterByPropertyPipe } from './filter-by-property.pipe';
import { FilterDropdownOptionsPipe } from './filter-dropdown-options.pipe';
import { FindByPropertyPipe } from './find-by-property.pipe';
import { GetMapValuePipe } from './get-map-value.pipe';
import { IsNullOrWhitespacePipe } from './is-null-or-whitespace.pipe';
import { MapByPropertyPipe } from './map-by-property.pipe';
import { ModuleHasClientAccessPipe } from './module-has-client-access.pipe';
import { SortPipe } from './sort.pipe';
import { StaticMessagePipe } from './static-message.pipe';
import { StringReplacePipe } from './string-replace.pipe';
import { ToUtcDateTimePipe } from './to-utc-date-time.pipe';
import { WarningIconPipe } from './warning-icon.pipe';
import { WarningTooltipPipe } from './warning-tooltip.pipe';
import { ArrayRemoveFalsyValuesPipe } from './array-remove-falsy-values.pipe';
import {
  BToMbPipe,
  FileAcceptDisplayPipe,
  FileSizePipe,
  MbToBPipe,
} from '@shared/components/file-upload';
import { CustomTimeDisplayPipe } from './custom-time-display.pipe';
import { GetMapKeyPipe } from './get-map-key.pipe';
import { ArrayMorePipe } from './array-more.pipe';
import { NumberFixedLengthPipe } from './number-fixed-length.pipe';
import { CustomFilenamePipe } from './custom-filename.pipe';
import { TrimPipe } from './trim.pipe';
import { DurationPipe } from './duration.pipe';
import { ApproveStatusTextPipe } from './approve-status-text.pipe';
import { ApproveStatusIconPipe } from './approve-status-icon.pipe';
import { ApproveStatusColorPipe } from './approve-status-color.pipe';
import { FlatMapByPropertyPipe } from './flat-map-by-property.pipe';
import { FormatMultipleRowsPipe } from './format-multiple-rows.pipe';
import { SumLogOfEventsTimePipe } from './sum-of-log-of-events-time.pipe';
import { CloneDeepPipe } from './clone-deep.pipe';
import { CalculatedCustomDataPipe } from './calculated-custom-data.pipe';
import { CustomDataFormulaPipe } from './custom-data-formula.pipe';

export {
  ModuleHasClientAccessPipe,
  AccountDisplayNamePipe,
  SortPipe,
  StaticMessagePipe,
  DprTitlePipe,
  StringReplacePipe,
  IsNullOrWhitespacePipe,
  GetMapValuePipe,
  GetMapKeyPipe,
  FilterByPropertyPipe,
  FindByPropertyPipe,
  WarningIconPipe,
  WarningTooltipPipe,
  FilterDropdownOptionsPipe,
  ToUtcDateTimePipe,
  MapByPropertyPipe,
  DprModalTitlePipe,
  ArrayRemoveFalsyValuesPipe,
  CustomTimeDisplayPipe,
  ArrayMorePipe,
  NumberFixedLengthPipe,
  CustomFilenamePipe,
  TrimPipe,
  DurationPipe,
  ApproveStatusTextPipe,
  ApproveStatusIconPipe,
  ApproveStatusColorPipe,
  FlatMapByPropertyPipe,
  FormatMultipleRowsPipe,
  SumLogOfEventsTimePipe,
  CloneDeepPipe,
  CalculatedCustomDataPipe,
  CustomDataFormulaPipe,
};

export const pipes = [
  ModuleHasClientAccessPipe,
  AccountDisplayNamePipe,
  SortPipe,
  StaticMessagePipe,
  DprTitlePipe,
  StringReplacePipe,
  IsNullOrWhitespacePipe,
  GetMapValuePipe,
  GetMapKeyPipe,
  FilterByPropertyPipe,
  FindByPropertyPipe,
  WarningIconPipe,
  WarningTooltipPipe,
  FilterDropdownOptionsPipe,
  ToUtcDateTimePipe,
  MapByPropertyPipe,
  DprModalTitlePipe,
  ArrayRemoveFalsyValuesPipe,
  FileSizePipe,
  FileAcceptDisplayPipe,
  MbToBPipe,
  BToMbPipe,
  CustomTimeDisplayPipe,
  ArrayMorePipe,
  NumberFixedLengthPipe,
  CustomFilenamePipe,
  TrimPipe,
  DurationPipe,
  ApproveStatusTextPipe,
  ApproveStatusIconPipe,
  ApproveStatusColorPipe,
  FlatMapByPropertyPipe,
  FormatMultipleRowsPipe,
  SumLogOfEventsTimePipe,
  CloneDeepPipe,
  CalculatedCustomDataPipe,
  CustomDataFormulaPipe,
];
